module.exports = __webpack_public_path__ + "assets/RestaurantMarker-552a24.svg";